let bmapPromise = null // 缓存加载地图的 Promise，防止重复加载

export default function loadBMap() {
  // 如果百度地图已经加载过，直接返回成功的 Promise
  if (window.BMap) {
    return Promise.resolve(window.BMap)
  }

  // 如果正在加载中，直接返回缓存的 Promise
  if (bmapPromise) {
    return bmapPromise
  }

  // 开始加载百度地图 JS SDK
  bmapPromise = new Promise((resolve, reject) => {
    // 百度地图加载成功后的全局回调函数
    window.initBMapCallback = () => {
      resolve(window.BMap)
    }

    const script = document.createElement('script')
    script.type = 'text/javascript'
    // 注意：必须带上 callback=initBMapCallback 参数
    script.src = `https://api.map.baidu.com/api?v=4.0&ak=${window.config.baiduAK}&callback=initBMapCallback`
    script.onerror = (err) => {
      reject(new Error('百度地图 JS 加载失败'))
      bmapPromise = null // 加载失败，清空缓存，允许下次重试
    }
    document.head.appendChild(script)
  })

  return bmapPromise
}